import { render } from "./SliderPage.vue?vue&type=template&id=7525368f&scoped=true"
import script from "./SliderPage.vue?vue&type=script&lang=js"
export * from "./SliderPage.vue?vue&type=script&lang=js"

import "./SliderPage.vue?vue&type=style&index=0&id=7525368f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7525368f"]])

export default __exports__